/* eslint-disable */
import { useContext, useState } from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import P, { shape } from 'prop-types';
import ConfirmationDialog from '../ConfirmationDialog';
import { MainContext } from '../../context/ApiContext';
import UserForm from '../UserForm';
import { MaskedTextField } from '../FormFields';

const InidicationReportGerVeicTableList = ({ listItem, title, states, sold, status }) => {
  const [open, setOpen] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [user, setUser] = useState(null);
  const [id, setId] = useState('');
  const [dialog, setDialog] = useState({
    msg: '',
    title: '',
  });
  // console.log(listItem);

  return (
    <>
      <ConfirmationDialog
        open={openConfirm}
        setOpen={setOpenConfirm}
        msg={dialog.msg.length > 0 ? dialog.msg : 'Dialog'}
        title={dialog.title.length > 0 ? dialog.title : 'Dialog'}
      />
      <UserForm open={open} setOpen={setOpen} title={title} user={user} />
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Cliente</TableCell>
              <TableCell>Veículo</TableCell>
              <TableCell>Data Indicação do Vendedor</TableCell>
              <TableCell>Data Venda / Não Venda</TableCell>
              <TableCell>Data Indicação do Processamento</TableCell>
              <TableCell>Data Criação da Proposta</TableCell>
              <TableCell>Indicado no Prazo</TableCell>
              <TableCell>Fase</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Indicador</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {listItem?.map((item) => (
              <TableRow key={item?.id}>
                <TableCell align="left">{item?.id}</TableCell>
                <TableCell>{item?.client || '-'}</TableCell>
                <TableCell>{item?.product || '-'}</TableCell>
                <TableCell>{item?.inviter_indication_time || '-'}</TableCell>
                <TableCell>{item?.sold_date || '-'}</TableCell>
                <TableCell>{item?.process_indication_time || '-'}</TableCell>
                <TableCell>{item?.proposal_date || '-'}</TableCell>
                <TableCell>{item?.indication_on_time || '-'}</TableCell>
                <TableCell>{item?.state || '-'}</TableCell>
                <TableCell>{item?.status || '-'}</TableCell>
                <TableCell>{item?.inviter_name || '-'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

InidicationReportGerVeicTableList.propTypes = {
  listItem: P.arrayOf(
    shape({
      id: P.number,
      name: P.string,
    })
  ),
  title: P.string.isRequired,
};

InidicationReportGerVeicTableList.defaultProps = {
  listItem: null,
};

export default InidicationReportGerVeicTableList;
